export default __webpack_public_path__ + "static/fire_protection_b.2c77dc4cd5f340fdc650c31dd24418ff.png";